import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import MyAssets from "./MyAssets";
import AssetDetails from "./AssetDetails";
import AssetRequests from "./AssetRequests";

const CompanyAssetsRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<MyAssets />} />
      <Route path="details/:id" element={<AssetDetails />} />
      <Route path="requests" element={<Navigate to="myAsset" replace />} />
      <Route path="requests/:tab" element={<AssetRequests />} />
      <Route path="*" element={<Navigate to="" replace />} />
    </Routes>
  );
};

export default CompanyAssetsRoutes;
